import React, { useState } from 'react';
import { HrActionText, HrBlockContainer, HrFlexContainer, HrWhite, Spinner } from '@components/styles/hr-styles';
import { HrSelect } from '@components/form/select';
import { useInfiniteQuery } from '@tanstack/react-query';
import { Activities } from '@components/activities';
import { eventTemplates } from '../../helpers/records';
import { eventLabels } from '../../constants/records';
import { getRecords } from '../../services/api';
import { EmptyRecords } from '../../../images/empty_records';
import { getColorIconAction, getIconAction } from '../../../utils/notifications';

const RECORDS_KEY = 'records';

const generateRecord = (recordData) => {
  const { keyEvent, username, requestName, comment } = recordData;

  const eventTemplate = eventTemplates[keyEvent];
  if (eventTemplate) {
    return eventTemplate(username, requestName, comment);
  }

  return 'Algo salió mal';
};

const keyEventOptions = Object.keys(eventLabels).map((key) => ({
  label: eventLabels[key],
  value: key
}));

export const Records = () => {
  const [selectType, setSelectType] = useState('all');
  const { data, fetchNextPage, hasNextPage, isFetchingNextPage, isLoading } = useInfiniteQuery(
    [RECORDS_KEY, selectType],
    ({ pageParam = 1 }) => getRecords({ pageParam, selectType }),
    {
      getNextPageParam: (lastPage, pages) => {
        if (lastPage?.data?.morePages) {
          return pages?.length + 1;
        }
        return null;
      }
    }
  );

  return (
    <HrFlexContainer backgroundColor={HrWhite} padding='32px' flexDirection='column' alignItems='start'>
      <HrBlockContainer maxWidth='300px' padding='0 0 12px 0'>
        <HrSelect
          selected={selectType}
          data={keyEventOptions}
          onChange={(value) => {
            setSelectType(value);
          }}
        />
      </HrBlockContainer>

      {isLoading && <Spinner className='hr-Charge' style={{ margin: '0 auto', fontSize: '16px', color: '#9a9a9a' }} />}
      {!isLoading && data?.pages[0]?.data?.data?.length === 0 && (
        <HrFlexContainer backgroundColor={HrWhite} padding='32px' flexDirection='column'>
          <div style={{ width: '100px', margin: '16px auto' }}>{EmptyRecords}</div>
          <p>No tienes acciones para mostrar en el historial</p>
        </HrFlexContainer>
      )}
      {data?.pages[0]?.data?.data?.length > 0 &&
        data.pages?.map((records) =>
          records?.data?.data?.map((record, index) =>
            record.photoLink ? (
              <Activities
                key={`${index * 1}`}
                src={record.photoLink}
                description={generateRecord(record)}
                date={record.date}
                time={record.time}
              />
            ) : (
              <Activities
                key={`${index * 1}`}
                iconName={getIconAction(record.keyEvent)}
                background={getColorIconAction(record.keyEvent)}
                description={generateRecord(record)}
                date={record.date}
                time={record.time}
              />
            )
          )
        )}

      {hasNextPage && (
        <HrActionText onClick={() => fetchNextPage()} color='#24BB72'>
          {isFetchingNextPage ? (
            <Spinner className='hr-Charge' style={{ margin: '0 auto', fontSize: '16px', color: '#9a9a9a' }} />
          ) : (
            '+ Cargar mas'
          )}
        </HrActionText>
      )}
    </HrFlexContainer>
  );
};
